import React from 'react';

const LoadingPlaces = () => {
  return (
    <div className="alert alert-primary mt-2 text-center mb-0">
      <h6>Buscando</h6>
      <p>Espere por favor...</p>
    </div>
  );
};

export default LoadingPlaces;
